var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"robokassa-setting"},[_c('text-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.model,
        'key': 'login',
        'prefix': 'cash_register_robokassa_',
        'validation': 'required'
      }
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.model,
        'key': 'pass1',
        'prefix': 'cash_register_robokassa_',
        'validation': 'required'
      }
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.model,
        'key': 'pass2',
        'prefix': 'cash_register_robokassa_',
        'validation': 'required'
      }
    }}}),_c('switch-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.model,
        'key': 'add_receipt',
        'prefix': 'cash_register_',
      }
    }},on:{"change":_vm.onAddReceiptChange}}),(_vm.model.add_receipt)?_c('select-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.model,
        'key': 'tax',
        'options': _vm.taxOptions,
        'clearable': false,
        'prefix': 'cash_register_robokassa_',
        'validation': 'required'
      }
    }}}):_vm._e(),(_vm.model.add_receipt)?_c('select-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.model,
        'key': 'sno',
        'options': _vm.snoOptions,
        'clearable': false,
        'prefix': 'cash_register_robokassa_',
        'validation': 'required'
      }
    }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }